import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnChanges,
  signal,
  TemplateRef,
  WritableSignal,
} from '@angular/core';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';

export interface TabProps {
  name: string;
  content: string | TemplateRef<unknown>;
}

@Component({
  selector: 'aw-tabs',
  imports: [CommonModule],
  templateUrl: './tabs.html',
  styleUrl: './tabs.css',
  host: {
    '[style.width]': 'width',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent implements OnChanges {
  @Input() properties: TabProps[] = [];
  @Input() width: string = '100%';

  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly selectedTab: WritableSignal<number> = signal(0);

  ngOnChanges(): void {
    if (this.selectedTab() >= this.properties.length) {
      this.selectedTab.set(0);
    }
  }

  protected getContentTemplate(
    content: TabProps['content']
  ): TemplateRef<unknown> | null {
    return typeof content === 'string' ? null : content;
  }

  protected getActiveColor(): string {
    if (this.corporateDesignService.isDarkModeActive()) {
      return this.corporateDesignService.corporateDesign().primaryDarkColor;
    }
    return this.corporateDesignService.corporateDesign().primaryColor;
  }
}
